import i18nextInstance from 'i18next';
import moment from 'moment';

let constraints = {};

i18nextInstance.on('initialized', () => {
  constraints = {
    from: {
      presence: {
        message: i18nextInstance.t('local:errors.from.presence'),
        allowEmpty: false
      },
      format: {
        pattern:
          '^(((0[1-9]|[12]\\d|3[01])\\/(0[13578]|1[02])\\/((19|[2-9]\\d)\\d{2}))|((0[1-9]|[12]\\d|30)\\/(0[13456789]|1[012])\\/((19|[2-9]\\d)\\d{2}))|((0[1-9]|1\\d|2[0-8])\\/02\\/((19|[2-9]\\d)\\d{2}))|(29\\/02\\/((1[6-9]|[2-9]\\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$',
        message: i18nextInstance.t('local:errors.from.format')
      },
      date: (value, attributes) => {
        if (value) {
          return {
            latest: moment.utc(attributes.to, 'DD/MM/YYYY'),
            tooLate: i18nextInstance.t('local:errors.from.tooLate'),
            notValid: i18nextInstance.t('local:errors.from.notValid')
          };
        }
      }
    },
    to: {
      presence: {
        message: i18nextInstance.t('local:errors.to.presence'),
        allowEmpty: false
      },
      format: {
        pattern:
          '^(((0[1-9]|[12]\\d|3[01])\\/(0[13578]|1[02])\\/((19|[2-9]\\d)\\d{2}))|((0[1-9]|[12]\\d|30)\\/(0[13456789]|1[012])\\/((19|[2-9]\\d)\\d{2}))|((0[1-9]|1\\d|2[0-8])\\/02\\/((19|[2-9]\\d)\\d{2}))|(29\\/02\\/((1[6-9]|[2-9]\\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$',
        message: i18nextInstance.t('local:errors.to.format')
      },
      date: (value, attributes) => {
        if (value) {
          return {
            earliest: moment.utc(attributes.from, 'DD/MM/YYYY'),
            tooEarly: i18nextInstance.t('local:errors.to.tooEarly'),
            notValid: i18nextInstance.t('local:errors.to.notValid')
          };
        }
      }
    }
  };
});

export default function () {
  return constraints;
}
